/* eslint-disable react/no-danger */
import React, { useCallback, useEffect, useState } from 'react';
import toHref, { getFeatureMedia } from '../tools/fetcher';
import { classNames } from '../tools/helpers';
import Button from './Button';
import { galleryStore } from '../store';

export default function SingleBlog({ className, data }) {
    const setDialogGallerySlider = (state) => {
        galleryStore.setState((prevState) => ({
            ...prevState,
            ...state,
        }));
    };

    const pathImg = (imgName) =>
        toHref(
            `/wp-content/plugins/react-plugin/react-app/build/assets/facility/${imgName}.svg`,
        );

    const FeatureMedia = useCallback(({ product }) => {
        const [imageSrc, setImageSrc] = useState();
        useEffect(() => {
            if (product.featured_media) {
                getFeatureMedia(product.featured_media).then((result) => {
                    if (!result?.code) {
                        setImageSrc(result?.source_url);
                    }
                });
            }
        }, [product]);

        return imageSrc ? (
            <img
                src={imageSrc}
                alt={product?.title?.rendered}
                width={160}
                height={160}
                className="mt-10 aspect-[6/5] w-full rounded-2xl object-contain sm:aspect-auto sm:h-[34.5rem]"
            />
        ) : (
            <div>No Image</div>
        );
    }, []);

    const Facility = useCallback(({ product }) => {
        const dt = product?.apartment_details;
        return (
            <>
                {dt.size && (
                    <>
                        <dt className="sr-only">Size</dt>
                        <dd className="mt-2 w-full flex-none text-base leading-7 text-gray-600">
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('home')}
                                    alt={'bg-size'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>
                                    {dt.size} meter
                                </span>
                            </li>
                        </dd>
                    </>
                )}
                {dt.wifi && dt.wifi === 'on' && (
                    <>
                        <dt className="sr-only">Wifi</dt>
                        <dd className="mt-2 w-full flex-none text-base leading-7 text-gray-600">
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('wifi')}
                                    alt={'bg-wifi'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>Free Wifi</span>
                            </li>
                        </dd>
                    </>
                )}
                {dt.bedrooms && (
                    <>
                        <dt className="sr-only">Bedrooms</dt>
                        <dd className="mt-2 w-full flex-none text-base leading-7 text-gray-600">
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('bed')}
                                    alt={'bg-bedrooms'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>
                                    {dt.bedrooms} Kasur
                                </span>
                            </li>
                        </dd>
                    </>
                )}
                {dt.for_men && dt.for_men === 'on' && (
                    <>
                        <dt className="sr-only">Kitchen</dt>
                        <dd className="mt-2 w-full flex-none text-base leading-7 text-gray-600">
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('bed')}
                                    alt={'bg-for_men'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>Khusus Putra</span>
                            </li>
                        </dd>
                    </>
                )}
                {dt.for_ladies && dt.for_ladies === 'on' && (
                    <>
                        <dt className="sr-only">Kitchen</dt>
                        <dd className="mt-2 w-full flex-none text-base leading-7 text-gray-600">
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('bed')}
                                    alt={'bg-for_ladies'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>Khusus Putri</span>
                            </li>
                        </dd>
                    </>
                )}
                {dt.bathroom && dt.bathroom === 'on' && (
                    <>
                        <dt className="sr-only">Shower</dt>
                        <dd className="mt-2 w-full flex-none text-base leading-7 text-gray-600">
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('shower')}
                                    alt={'bg-bathroom'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>
                                    K. Mandi Dalam
                                </span>
                            </li>
                        </dd>
                    </>
                )}
                {dt.kitchen && dt.kitchen === 'on' && (
                    <>
                        <dt className="sr-only">Kitchen</dt>
                        <dd className="mt-2 w-full flex-none text-base leading-7 text-gray-600">
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('kitchen')}
                                    alt={'bg-kitchen'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>Dapur</span>
                            </li>
                        </dd>
                    </>
                )}
                {dt.furnished && dt.furnished === 'on' && (
                    <>
                        <dt className="sr-only">Furnished</dt>
                        <dd className="mt-2 w-full flex-none text-base leading-7 text-gray-600">
                            <li className="flex items-center sm:items-start gap-2 sm:gap-3">
                                <img
                                    src={pathImg('furnished')}
                                    alt={'bg-furnished'}
                                    className="h-4 w-4 sm:h-6 sm:w-6"
                                />
                                <span className={'text-sm'}>Furnished</span>
                            </li>
                        </dd>
                    </>
                )}
            </>
        );
    }, []);

    const Gallery = useCallback(({ product }) => {
        const dt = product?.image_gallery;
        return (
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-5 mt-2">
                {dt.map((imageSrc, index) => (
                    <div
                        key={index}
                        className={'cursor-pointer'}
                        role="button"
                        tabIndex={0}
                        onClick={() =>
                            setDialogGallerySlider({
                                open: true,
                                imageActive: index,
                                images: data?.image_gallery || [],
                            })
                        }
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                setDialogGallerySlider({
                                    open: true,
                                    imageActive: index,
                                    images: data?.image_gallery || [],
                                });
                            }
                        }}
                    >
                        <img
                            src={imageSrc}
                            alt={imageSrc}
                            width={160}
                            height={160}
                            className={
                                'object-contain rounded-2xl h-full w-full'
                            }
                        />
                    </div>
                ))}
            </div>
        );
    }, []);

    return (
        <div
            className={classNames(
                'mx-auto flex flex-col items-end justify-between gap-10 sm:flex-row',
                className,
            )}
        >
            <div className="w-full sm:max-w-lg sm:flex-auto">
                <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                    {data?.title?.rendered}
                </h2>
                <p className={'text-apart-black-50 text-base'}>
                    {data?.apartment_details?.address}
                </p>
                <div
                    className="mt-6 leading-8 text-gray-600"
                    dangerouslySetInnerHTML={{
                        __html: data?.content?.rendered,
                    }}
                />
                <FeatureMedia product={data} />
            </div>
            <div className="w-full sm:max-w-xl sm:flex-auto">
                <h3 className="sr-only">Fasilitas</h3>
                <ul className="-my-8 flex flex-col">
                    <li className="py-8">
                        <dl className="relative flex flex-wrap gap-3">
                            <dt className="sr-only">Fasilitas</dt>
                            <dd className="w-full flex-none text-lg font-semibold tracking-tight text-gray-900">
                                <div>Fasilitas</div>
                            </dd>
                            <Facility product={data} />
                        </dl>
                    </li>
                    <li className="order-first sm:order-1 py-8">
                        <dl className="relative flex flex-wrap gap-3">
                            <dt className="sr-only">Galeri</dt>
                            <dd className="w-full flex-none text-lg font-semibold tracking-tight text-gray-900">
                                <div>Galeri</div>
                            </dd>
                            <Gallery product={data} />
                        </dl>
                    </li>
                    <li className="py-8 order-last">
                        <dl className="relative flex flex-wrap gap-3">
                            <dt className="sr-only">Hubungi Kami</dt>
                            <dd className="w-full flex-none text-lg font-semibold tracking-tight text-gray-900">
                                <Button
                                    type={'a'}
                                    target={'_blank'}
                                    href={data?.apartment_details?.link_url}
                                    className={'bg-apart-green-50 w-full mt-6'}
                                >
                                    Hubungi Kami
                                </Button>
                            </dd>
                        </dl>
                    </li>
                </ul>
            </div>
        </div>
    );
}
